module.exports = __webpack_public_path__ + "bg-event.ffcf719.png";